(function () {
  const STORAGE_KEY   = 'tyraStaticCart';
  const STORE_ORIGIN  = 'https://www.tyranatura.lt';
  const FREE_SHIP_EUR = (window.TyraShipping?.thresholdCents ?? 3000) / 100;

  /* ── Inject cart drawer styles (self-contained, no dependency on products.css) ── */
  (function injectStyles() {
    if (document.getElementById('tyra-cart-styles')) return;
    const s = document.createElement('style');
    s.id = 'tyra-cart-styles';
    s.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800;9..40,900&display=swap');

      .cart-drawer-root{position:relative;z-index:1200}
      .cart-drawer-overlay{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:1200;opacity:0;pointer-events:none;transition:opacity .3s ease}
      .cart-drawer-open .cart-drawer-overlay{opacity:1;pointer-events:auto}
      .cart-drawer-open{overflow:hidden;touch-action:none}
      .cart-drawer{position:fixed;top:0;right:0;width:min(420px,100vw);height:100vh;height:100dvh;background:#F7F2EC;box-shadow:-16px 0 48px rgba(0,0,0,.11);transform:translateX(100%);transition:transform .3s ease;display:flex;flex-direction:column;z-index:1201;font-family:'DM Sans',system-ui,sans-serif}
      .cart-drawer-open .cart-drawer{transform:translateX(0)}

      .cdn-bundle-summary{font-size:12px;color:#5C5C5C;margin-top:5px}.cdn-composition summary{cursor:pointer;font-size:12px;color:#1A9E7E;padding:8px 0}.cdn-composition .cdn-chip{border-radius:6px;overflow-wrap:anywhere}
      /* header */
      .cdn-head{display:flex;align-items:flex-start;justify-content:space-between;padding:20px 20px 16px;background:#fff;border-bottom:1px solid #DEDBD5;flex-shrink:0;gap:12px}
      .cdn-eyebrow{font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#2DBD9A;margin-bottom:4px;display:block}
      .cdn-title{font-family:'DM Sans',system-ui,sans-serif;font-size:22px;font-weight:900;letter-spacing:-.04em;color:#000;line-height:1.1;display:flex;align-items:center;gap:10px}
      .cdn-count{display:inline-flex;align-items:center;justify-content:center;min-width:22px;height:22px;border-radius:100px;padding:0 6px;background:#F7F2EC;color:#2DBD9A;font-size:11px;font-weight:700;font-family:'DM Sans',system-ui,sans-serif}
      .cdn-close-btn{width:36px;height:36px;border-radius:50%;flex-shrink:0;background:#F7F2EC;color:#000;display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;transition:background .2s,color .2s;margin-top:2px}
      .cdn-close-btn:hover{background:#000;color:#fff}
      .cdn-close-btn svg{pointer-events:none}

      /* scroll area */
      .cdn-lines-wrap{flex:1;min-height:0;overflow-y:auto;padding:12px;display:flex;flex-direction:column;gap:10px}

      /* hidden attribute must win over display:flex rules */
      [hidden]{display:none!important}

      /* empty */
      .cdn-empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:40px 24px;gap:10px;color:#5C5C5C}
      .cdn-empty svg{opacity:.2;margin-bottom:8px}
      .cdn-empty strong{font-family:'DM Sans',system-ui,sans-serif;font-size:22px;font-weight:900;letter-spacing:-.04em;color:#000;display:block}
      .cdn-empty p{font-size:14px}

      /* item card */
      .cdn-item{display:grid;grid-template-columns:72px 1fr;gap:12px;align-items:start;background:#fff;border:1px solid #DEDBD5;border-radius:12px;padding:12px}
      .cdn-item-img{width:72px;height:72px;border-radius:8px;background:#F7F2EC;overflow:hidden;display:flex;align-items:center;justify-content:center;flex-shrink:0}
      .cdn-item-img img{width:100%;height:100%;object-fit:contain;display:block}
      .cdn-item-body{display:flex;flex-direction:column;gap:6px;min-width:0}
      .cdn-item-name{font-family:'DM Sans',system-ui,sans-serif;font-size:14px;font-weight:700;color:#000;line-height:1.25;text-decoration:none;display:block}
      .cdn-item-name:hover{text-decoration:underline}
      .cdn-choices{display:flex;flex-wrap:wrap;gap:4px}
      .cdn-chip{display:inline-flex;align-items:center;background:rgba(45,189,154,.1);color:#1A9E7E;border:1px solid rgba(45,189,154,.3);border-radius:100px;padding:2px 8px;font-size:11px;font-weight:600}

      /* qty + price row */
      .cdn-item-foot{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:2px}
      .cdn-qty{display:inline-flex;align-items:center;border:1.5px solid #DEDBD5;border-radius:100px;overflow:hidden}
      .cdn-qty-btn{width:30px;height:30px;font-size:17px;font-weight:400;color:#000;display:flex;align-items:center;justify-content:center;cursor:pointer;border:none;background:none;transition:background .15s;font-family:'DM Sans',system-ui,sans-serif}
      .cdn-qty-btn:hover{background:#F7F2EC}
      .cdn-qty-val{min-width:26px;text-align:center;font-size:13px;font-weight:700;color:#000;font-family:'DM Sans',system-ui,sans-serif}
      .cdn-pricing{text-align:right;line-height:1.3}
      .cdn-unit-price{display:block;font-size:11px;color:#9A9A9A}
      .cdn-line-price{font-size:15px;font-weight:800;color:#000;font-family:'DM Sans',system-ui,sans-serif}

      /* footer */
      .cdn-foot{max-height:65vh;max-height:65dvh;overflow-y:auto;background:#fff;border-top:1px solid #DEDBD5;padding:14px 20px 20px;display:flex;flex-direction:column;gap:12px;flex-shrink:0}

      /* shipping bar */
      .cdn-ship{background:rgba(45,189,154,.08);border:1px solid rgba(45,189,154,.2);border-radius:10px;padding:10px 14px}
      .cdn-ship-label{font-size:12px;color:#1A9E7E;font-weight:600;margin-bottom:7px;display:block}
      .cdn-ship-track{height:5px;background:rgba(45,189,154,.15);border-radius:3px;overflow:hidden}
      .cdn-ship-fill{height:100%;background:#2DBD9A;border-radius:3px;transition:width .4s ease}

      /* total */
      .cdn-total-row{display:flex;align-items:baseline;justify-content:space-between;font-size:14px;color:#000}
      .cdn-total-row strong{font-family:'DM Sans',system-ui,sans-serif;font-size:24px;font-weight:900;letter-spacing:-.04em;color:#000}

      /* buttons */
      .cdn-btn-checkout{display:flex;align-items:center;justify-content:center;padding:14px;background:#000;color:#fff;border-radius:100px;font-size:15px;font-weight:800;text-decoration:none;text-align:center;transition:background .2s,transform .2s;font-family:'DM Sans',system-ui,sans-serif;border:none;cursor:pointer}
      .cdn-btn-checkout:hover{background:#222;transform:translateY(-2px)}
      .cdn-btn-continue{display:flex;align-items:center;justify-content:center;padding:11px;border:1.5px solid #DEDBD5;color:#5C5C5C;border-radius:100px;font-size:14px;font-weight:600;width:100%;cursor:pointer;background:none;font-family:'DM Sans',system-ui,sans-serif;transition:background .2s,color .2s,border-color .2s;text-decoration:none}
      .cdn-btn-continue:hover{background:#F7F2EC;color:#000;border-color:#000}

      /* payment icons strip */
      .cdn-pay-strip{display:flex;align-items:center;justify-content:center;gap:5px;flex-wrap:wrap;padding-top:4px}
      .cdn-pay-strip svg{height:20px;border-radius:3px}

      /* fly dot */
      .tyra-fly-dot{position:fixed;width:14px;height:14px;border-radius:50%;background:#2DBD9A;z-index:9999;pointer-events:none;transform:scale(1);opacity:1;transition:left .5s cubic-bezier(.4,0,.2,1),top .5s cubic-bezier(.4,0,.2,1),opacity .45s ease,transform .45s ease}

      /* badge pop keyframe */
      @keyframes badge-pop{0%{transform:scale(1)}40%{transform:scale(1.55)}100%{transform:scale(1)}}
      .badge-popping{animation:badge-pop .3s ease forwards}

      /* upsell */
      .cdn-upsell{padding:10px 12px;border-top:1px solid #DEDBD5;background:#F7F2EC;flex-shrink:0}
      .cdn-upsell-label{font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#9A9A9A;margin-bottom:8px;display:block}
      .cdn-upsell-grid{display:flex;flex-direction:column;gap:6px}
      .cdn-upsell-card{background:#fff;border:1px solid #DEDBD5;border-radius:10px;padding:8px 10px;display:flex;flex-direction:row;align-items:center;gap:10px}
      .cdn-upsell-card-img{width:48px;height:48px;border-radius:8px;overflow:hidden;background:#F7F2EC;display:block;flex-shrink:0}
      .cdn-upsell-card-img img{width:100%;height:100%;object-fit:contain}
      .cdn-upsell-name{font-size:13px;font-weight:700;color:#000;line-height:1.25;flex:1;display:block;text-decoration:none;min-width:0}
      .cdn-upsell-name:hover{text-decoration:underline}
      .cdn-upsell-foot{display:flex;align-items:center;gap:8px;flex-shrink:0}
      .cdn-upsell-price{font-size:13px;font-weight:800;color:#000}
      .cdn-upsell-add{width:28px;height:28px;border-radius:50%;background:#2DBD9A;color:#fff;border:none;font-size:18px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s;flex-shrink:0}
      .cdn-upsell-add:hover{background:#1A9E7E}
    `;
    document.head.appendChild(s);
  })();

  const fmt = new Intl.NumberFormat('lt-LT', { style: 'currency', currency: 'EUR' });

  function formatMoney(eur) {
    return fmt.format(eur || 0).replace(/\s/g, ' '); // narrow no-break space
  }

  function parseMoney(text) {
    // Convert Lithuanian decimal comma → dot, then grab first decimal number
    const match = String(text || '').replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    return match ? Number(match[1]) : 0;
  }

  /* ── LocalStorage cart (static/preview pages) ── */

  function readStaticCart() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch { return []; }
  }

  function writeStaticCart(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function addStaticItem(item) {
    const items = readStaticCart();
    const existing = items.find(l => l.key === item.key);
    if (existing) {
      existing.quantity += item.quantity;
    } else {
      items.push(item);
    }
    writeStaticCart(items);
  }

  function updateStaticLine(index, delta) {
    const items = readStaticCart();
    if (!items[index]) return;
    items[index].quantity += delta;
    if (items[index].quantity <= 0) items.splice(index, 1);
    writeStaticCart(items);
    renderDrawer();
    renderLocalCartPage();
  }

  /* ── Shopify AJAX cart ── */

  function isAssetHost() {
    return /cdn\.shopify\.com|shopifycdn\.net/.test(window.location.hostname);
  }

  function cartUrl() {
    return isAssetHost() ? `${STORE_ORIGIN}/cart` : '/cart';
  }

  function checkoutUrl() {
    return isAssetHost() ? `${STORE_ORIGIN}/checkout` : '/checkout';
  }

  function cartUrlWithStaticItems() {
    const items = readStaticCart();
    if (!items.length) return cartUrl();
    const payload = encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(items)))));
    return `${cartUrl()}?tyra_cart=${payload}`;
  }

  async function getShopifyCart() {
    try {
      const res = await fetch(isAssetHost() ? `${STORE_ORIGIN}/cart.js` : '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'include'
      });
      return res.ok ? res.json() : null;
    } catch { return null; }
  }

  async function updateShopifyLine(line1based, newQty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line1based, quantity: newQty })
      });
    } catch { /* silent – next render will re-read */ }
    renderDrawer();
    renderLocalCartPage();
  }

  /* ── Drawer DOM ── */

  function ensureDrawer() {
    let drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) return drawer;

    const root = document.createElement('div');
    root.className = 'cart-drawer-root';
    root.innerHTML = `
      <div class="cart-drawer-overlay" data-cart-close></div>
      <aside class="cart-drawer" data-cart-drawer role="dialog" aria-modal="true" aria-label="Krepšelis" aria-hidden="true" inert>

        <header class="cdn-head">
          <div>
            <p class="cdn-eyebrow">Tyra Natura</p>
            <h2 class="cdn-title">
              Krepšelis
              <span class="cdn-count" data-cart-drawer-count></span>
            </h2>
          </div>
          <button type="button" class="cdn-close-btn" data-cart-close aria-label="Uždaryti">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </header>

        <div class="cdn-lines-wrap" data-cart-drawer-lines></div>



        <div class="cdn-empty" data-cart-drawer-empty hidden>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          <strong>Krepšelis tuščias</strong>
          <p>Išsirink produktą ir jis atsiras čia.</p>
        </div>

        <footer class="cdn-foot">
          <div class="cdn-ship" data-cdn-ship>
            <p class="cdn-ship-label" data-cdn-ship-label></p>
            <div class="cdn-ship-track">
              <div class="cdn-ship-fill" data-cdn-ship-fill style="width:0%"></div>
            </div>
          </div>
          <div class="cdn-total-row">
            <span>Tarpinė suma</span>
            <strong data-cart-drawer-total>€0.00</strong>
          </div>
          <a href="${checkoutUrl()}" class="cdn-btn-checkout" data-cart-checkout-link>
            Pereiti prie apmokėjimo →
          </a>
          <a href="${cartUrl()}" class="cdn-btn-continue" data-cart-link>
            Eiti į krepšelį
          </a>
          <button type="button" class="cdn-btn-continue" data-cart-close>
            Tęsti apsipirkimą
          </button>
        <div class="cdn-upsell" data-cart-upsell hidden>
          <span class="cdn-upsell-label">💡 Gal patiks?</span>
          <div class="cdn-upsell-grid" data-cart-upsell-items></div>
        </div>
          <div class="cdn-pay-strip">${(document.getElementById('payment-icons-tmpl')||{}).innerHTML||''}</div>
        </footer>

      </aside>
    `;
    document.body.appendChild(root);
    root.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeDrawer));
    return root.querySelector('[data-cart-drawer]');
  }

  let drawerReturnFocus = null;
  function openDrawer() {
    if (!document.body.classList.contains('cart-drawer-open')) drawerReturnFocus = document.activeElement;
    ensureDrawer();
    document.body.classList.add('cart-drawer-open');
    document.querySelector('[data-cart-drawer]').removeAttribute('inert');
    document.querySelector('[data-cart-drawer]').setAttribute('aria-hidden', 'false');
    renderDrawer();
    document.querySelector('[data-cart-drawer] [data-cart-close]')?.focus();
  }

  function closeDrawer() {
    document.body.classList.remove('cart-drawer-open');
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) { drawer.setAttribute('aria-hidden', 'true'); drawer.setAttribute('inert', ''); }
    if (drawerReturnFocus?.isConnected) drawerReturnFocus.focus();
  }

  document.addEventListener('keydown', event => {
    if (!document.body.classList.contains('cart-drawer-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    const drawer = document.querySelector('[data-cart-drawer]');
    const controls = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]')).filter(el => el.getClientRects().length);
    if (!controls.length) return;
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {event.preventDefault();first.focus();}
  });
  window.TyraCart = { open: openDrawer, close: closeDrawer, refresh: renderDrawer };

  /* ── Markup builders ── */

  function shopifyLineMarkup(item, lineIndex) {
    // lineIndex is 1-based (Shopify convention)
    const unitPrice = item.final_price / 100;   // unit price after line discounts
    const linePrice = item.final_line_price / 100; // already qty * unit
    const img = item.image
      ? `<img src="${item.image}" alt="${escHtml(item.product_title)}" loading="lazy">`
      : '';
    const properties = Object.entries(item.properties || {})
      .filter(([k, v]) => k.charAt(0) !== '_' && v);
    const bundle = properties.some(([key]) => /^(main|energy|crunch|dziovanis|sprouty) — /.test(key));
    const cleanKey = key => bundle ? key.replace(/^(main|energy|crunch|dziovanis|sprouty) — /, '') : key;
    const chips = properties.map(([k, v]) => `<span class="cdn-chip">${escHtml(cleanKey(k))}: ${escHtml(v)}</span>`).join('');
    let summary = '';
    if (bundle && item.handle === '7-energerieciu-skoniu-rinkinys') summary = '7 EnerGeriečiai · po 1 kiekvieno skonio';
    if (bundle && item.handle === 'tyra-natura-pazintinis-rinkinys-13-uzkandziu') summary = '13 užkandžių iš 4 grupių';
    if (bundle && item.handle === '12-batoneliu-dezute') {
      summary = properties.filter(([k, v]) => /^main — Batonėlis (Sprouty|Jėgos maistas)/.test(k) && Number(v) > 0)
        .map(([k, v]) => `${v} ${k.includes('Sprouty') ? 'Sprouty' : 'Jėgos maisto'}`).join(' + ');
    }
    const choicesMarkup = !chips ? '' : bundle
      ? `${summary ? '<p class="cdn-bundle-summary">' + escHtml(summary) + '</p>' : ''}<details class="cdn-composition"><summary>Peržiūrėti rinkinio sudėtį</summary><div class="cdn-choices">${chips}</div></details>`
      : `<div class="cdn-choices">${chips}</div>`;

    return `
      <div class="cdn-item" data-shopify-line="${lineIndex}">
        <a href="${escHtml(item.url)}" class="cdn-item-img">${img}</a>
        <div class="cdn-item-body">
          <a href="${escHtml(item.url)}" class="cdn-item-name">${escHtml(item.product_title)}${item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + escHtml(item.variant_title) : ''}</a>
          ${choicesMarkup}
          <div class="cdn-item-foot">
            <div class="cdn-qty">
              <button type="button" class="cdn-qty-btn" data-shopify-dec="${lineIndex}" ${item.quantity <= 1 ? '' : ''}>−</button>
              <span class="cdn-qty-val">${item.quantity}</span>
              <button type="button" class="cdn-qty-btn" data-shopify-inc="${lineIndex}">+</button>
            </div>
            <div class="cdn-pricing">
              <span class="cdn-unit-price">${formatMoney(unitPrice)} / vnt.</span>
              <strong class="cdn-line-price">${formatMoney(linePrice)}</strong>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function staticLineMarkup(item, index) {
    const linePrice = item.price * item.quantity;
    const img = item.image
      ? `<img src="${item.image}" alt="${escHtml(item.title)}" loading="lazy">`
      : '';
    const choices = Array.isArray(item.choices) ? item.choices : [];
    const chips = choices.map(c => `<span class="cdn-chip">${c.quantity}x ${escHtml(c.label)}</span>`).join('');

    return `
      <div class="cdn-item" data-static-index="${index}">
        <a href="${escHtml(item.url)}" class="cdn-item-img">${img}</a>
        <div class="cdn-item-body">
          <a href="${escHtml(item.url)}" class="cdn-item-name">${escHtml(item.title)}</a>
          ${chips ? `<div class="cdn-choices">${chips}</div>` : ''}
          <div class="cdn-item-foot">
            <div class="cdn-qty">
              <button type="button" class="cdn-qty-btn" data-static-dec="${index}">−</button>
              <span class="cdn-qty-val">${item.quantity}</span>
              <button type="button" class="cdn-qty-btn" data-static-inc="${index}">+</button>
            </div>
            <div class="cdn-pricing">
              <span class="cdn-unit-price">${formatMoney(item.price)} / vnt.</span>
              <strong class="cdn-line-price">${formatMoney(linePrice)}</strong>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Upsell ── */

  async function renderUpsell(cartProductIds, isEmpty) {
    const upsellEl    = document.querySelector('[data-cart-upsell]');
    const upsellItems = document.querySelector('[data-cart-upsell-items]');
    if (!upsellEl || !upsellItems) return;
    if (isEmpty) { upsellEl.hidden = true; return; }

    try {
      const res = await fetch('/collections/all/products.json?limit=50');
      if (!res.ok) throw new Error();
      const { products } = await res.json();
      const candidates = products.filter(p =>
        !cartProductIds.includes(p.id) &&
        p.variants.some(v => v.available)
      );
      if (!candidates.length) { upsellEl.hidden = true; return; }

      const pick = candidates.sort(() => Math.random() - 0.5).slice(0, 2);

      upsellItems.innerHTML = pick.map(p => {
        const variant = p.variants.find(v => v.available) || p.variants[0];
        const price   = formatMoney(parseFloat(variant.price));
        const imgSrc  = p.images[0]?.src || '';
        const img     = imgSrc ? `<img src="${imgSrc}" alt="${escHtml(p.title)}" loading="lazy">` : '';
        return `
          <div class="cdn-upsell-card">
            <a href="/products/${p.handle}" class="cdn-upsell-card-img">${img}</a>
            <a href="/products/${p.handle}" class="cdn-upsell-name">${escHtml(p.title)}</a>
            <div class="cdn-upsell-foot">
              <span class="cdn-upsell-price">${price}</span>
              <button type="button" class="cdn-upsell-add" data-upsell-variant="${variant.id}" title="Pridėti">+</button>
            </div>
          </div>
        `;

      }).join('');

      upsellEl.hidden = false;
    } catch {
      upsellEl.hidden = true;
    }
  }

  /* ── Render ── */

  async function renderDrawer() {
    const drawer     = ensureDrawer();
    const linesWrap  = drawer.querySelector('[data-cart-drawer-lines]');
    const emptyEl    = drawer.querySelector('[data-cart-drawer-empty]');
    const totalEl    = drawer.querySelector('[data-cart-drawer-total]');
    const countEl    = drawer.querySelector('[data-cart-drawer-count]');
    const shipLabel  = drawer.querySelector('[data-cdn-ship-label]');
    const shipFill   = drawer.querySelector('[data-cdn-ship-fill]');
    const linkEl     = drawer.querySelector('[data-cart-link]');

    const staticItems   = readStaticCart();
    const shopifyCart   = await getShopifyCart();
    const shopifyLines  = shopifyCart?.items || [];

    let html        = '';
    let totalEur    = 0;
    let totalQty    = 0;

    // Shopify lines (1-based index)
    shopifyLines.forEach((item, i) => {
      totalEur += item.final_line_price / 100;
      totalQty += item.quantity;
      html += shopifyLineMarkup(item, i + 1);
    });

    // Static lines
    staticItems.forEach((item, i) => {
      totalEur += item.price * item.quantity;
      totalQty += item.quantity;
      html += staticLineMarkup(item, i);
    });

    linesWrap.innerHTML = html;
    linesWrap.hidden    = !html;
    emptyEl.hidden      = Boolean(html);

    if (shopifyCart && Number.isFinite(shopifyCart.total_price)) {
      totalEur = shopifyCart.total_price / 100 + staticItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    }
    totalEl.textContent  = formatMoney(totalEur);
    countEl.textContent  = totalQty || '';

    // Free shipping progress
    const pct = Math.min(100, (totalEur / FREE_SHIP_EUR) * 100);
    if (shipFill) shipFill.style.width = `${pct}%`;
    if (shipLabel) {
      if (totalEur >= FREE_SHIP_EUR) {
        shipLabel.textContent = '✓ Nemokamai į Lietuvos paštomatus';
      } else {
        const remaining = (FREE_SHIP_EUR - totalEur).toFixed(2).replace('.', ',');
        shipLabel.textContent = `Dar ${remaining} € iki nemokamo pristatymo į Lietuvos paštomatus`;
      }
    }

    if (shopifyCart?.currency && shopifyCart.currency !== 'EUR') {
      if (shipLabel) shipLabel.textContent = 'Pristatymo kainą matysi atsiskaitydamas';
      if (shipFill) shipFill.style.width = '0%';
    }
    if (shipLabel && staticItems.length) shipLabel.textContent += ' · Preliminariai; statinės prekės tikrinamos atsiskaitant';
    if (linkEl) linkEl.setAttribute('href', cartUrlWithStaticItems());

    updateNavCartBadge(totalQty);
    renderUpsell(shopifyLines.map(item => item.product_id), !html);
  }

  /* ── Nav badge ── */

  function updateNavCartBadge(count) {
    const badge = document.querySelector('[data-cart-nav-count]');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.classList.add('has-items');
      badge.classList.remove('badge-popping');
      void badge.offsetWidth; // reflow to restart animation
      badge.classList.add('badge-popping');
    } else {
      badge.textContent = '';
      badge.classList.remove('has-items', 'badge-popping');
    }
  }

  /* ── Add-to-cart animation ── */

  function animateAddToCart(btn) {
    if (!btn) return;

    // Button success flash
    const origHtml = btn.innerHTML;
    const origBg   = btn.style.background;
    btn.innerHTML  = '✓ Pridėta!';
    btn.style.cssText += ';background:#2DBD9A!important;transform:scale(1.04);transition:all .15s ease';
    setTimeout(() => {
      btn.innerHTML      = origHtml;
      btn.style.background = origBg;
      btn.style.transform  = '';
    }, 1400);

    // Fly dot from button → cart badge
    const target  = document.querySelector('[data-cart-nav-count]') || document.querySelector('.nav-cart');
    if (!target) return;
    const from = btn.getBoundingClientRect();
    const to   = target.getBoundingClientRect();

    const dot = document.createElement('div');
    dot.className = 'tyra-fly-dot';
    dot.style.left = `${from.left + from.width / 2 - 7}px`;
    dot.style.top  = `${from.top  + from.height / 2 - 7}px`;
    document.body.appendChild(dot);

    requestAnimationFrame(() => requestAnimationFrame(() => {
      dot.style.left      = `${to.left + to.width / 2 - 7}px`;
      dot.style.top       = `${to.top  + to.height / 2 - 7}px`;
      dot.style.opacity   = '0';
      dot.style.transform = 'scale(0)';
    }));

    setTimeout(() => dot.remove(), 600);
  }

  /* ── Event bindings ── */

  function bindControls() {
    // Static cart controls (delegated — drawer is injected after DOMContentLoaded)
    document.addEventListener('click', e => {
      const inc    = e.target.closest('[data-static-inc]');
      const dec    = e.target.closest('[data-static-dec]');
      const remove = e.target.closest('[data-static-remove]');
      if (inc)    updateStaticLine(Number(inc.dataset.staticInc), 1);
      if (dec)    updateStaticLine(Number(dec.dataset.staticDec), -1);
      if (remove) updateStaticLine(Number(remove.dataset.staticRemove), -999);

      // Upsell add
      const upsellAdd = e.target.closest('[data-upsell-variant]');
      if (upsellAdd) {
        const variantId = Number(upsellAdd.dataset.upsellVariant);
        upsellAdd.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(() => {
          animateAddToCart(upsellAdd);
          setTimeout(renderDrawer, 600);
        }).catch(() => { upsellAdd.disabled = false; });
      }

      // Shopify cart controls
      const sinc = e.target.closest('[data-shopify-inc]');
      const sdec = e.target.closest('[data-shopify-dec]');
      if (sinc) {
        const line = Number(sinc.dataset.shopifyInc);
        const qtyEl = sinc.closest('.cdn-item').querySelector('.cdn-qty-val');
        updateShopifyLine(line, Number(qtyEl?.textContent || 1) + 1);
      }
      if (sdec) {
        const line = Number(sdec.dataset.shopifyDec);
        const qtyEl = sdec.closest('.cdn-item').querySelector('.cdn-qty-val');
        const newQty = Number(qtyEl?.textContent || 1) - 1;
        updateShopifyLine(line, Math.max(0, newQty));
      }
    });
  }

  function bindShopifyForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      let submitting = false;
      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (submitting) return;
        submitting = true;
        const btn = form.querySelector('[type="submit"]');
        const originalText = btn?.textContent;
        btn?.setAttribute('disabled', 'disabled');
        if (btn) btn.textContent = 'Pridedama…';
        let status = form.querySelector('[data-cart-form-status]');
        if (!status) {
          status = document.createElement('p');
          status.dataset.cartFormStatus = '';
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          status.style.cssText = 'font-size:13px;line-height:1.6;margin:12px 0';
          form.appendChild(status);
        }
        status.textContent = '';
        try {
          const res = await fetch(form.action.replace(/(?:\.js)?\/?$/, '.js'), {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' }
          });
          const result = await res.json();
          if (!res.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Nepavyko pridėti prekės. Patikrink pasirinktą kiekį ir bandyk dar kartą.');
          status.textContent = 'Pridėta į krepšelį.';
          animateAddToCart(btn);
          openDrawer();
        } catch (error) {
          status.textContent = error instanceof TypeError ? 'Ryšio klaida. Patikrink krepšelį prieš bandydamas dar kartą.' : error.message || 'Nepavyko pridėti prekės. Bandyk dar kartą.';
        } finally {
          submitting = false;
          btn?.removeAttribute('disabled');
          if (btn) btn.textContent = originalText;
        }
      });
    });
  }

  /* Capture current static product info from the page */
  function getCurrentStaticProduct() {
    const title    = document.querySelector('.product-title, .bundle-title, h1')?.textContent?.trim() || 'Tyra Natura produktas';
    const priceEl  = document.querySelector('.price-current');
    const priceText = priceEl?.textContent || '€0';
    const image    = document.querySelector('.gallery-main img, .bundle-hero img, .product-hero img')?.getAttribute('src') || '';
    const qty      = Math.max(1, parseInt(document.querySelector('#qty, .qty-input')?.value || '1', 10));
    const choices  = currentBundleChoices();
    const keyBase  = window.location.pathname.split('/').pop() || title.toLowerCase().replace(/\s+/g, '-');
    const key      = choices.length
      ? `${keyBase}::${choices.map(c => `${c.label}:${c.quantity}`).join('|')}`
      : keyBase;

    return { key, title, price: parseMoney(priceText), quantity: qty, image, url: window.location.href, choices };
  }

  function currentBundleChoices() {
    const chips = Array.from(document.querySelectorAll('#summary-items .flavor-summary-chip'));
    return chips.map(chip => {
      const text  = chip.textContent.trim();
      const match = text.match(/^(\d+)x\s+(.+)$/);
      return match ? { quantity: Number(match[1]), label: match[2] } : { quantity: 1, label: text };
    }).filter(c => c.label);
  }

  function bindStaticAddButtons() {
    document.querySelectorAll('a.btn').forEach(link => {
      const label = link.textContent || '';
      const href  = link.getAttribute('href') || '';
      if (label.includes('krepšel') && !href.includes('/cart')) {
        link.addEventListener('click', e => {
          e.preventDefault();
          addStaticItem(getCurrentStaticProduct());
          animateAddToCart(link);
          setTimeout(openDrawer, 560);
        });
      }
    });
  }

  /* ── Local cart page rendering (full cart page) ── */
  function renderLocalCartPage() {
    const page = document.querySelector('#local-cart-page');
    if (!page) return;

    const items = readStaticCart();
    const lines = page.querySelector('[data-local-cart-lines]');
    const total = page.querySelector('[data-local-cart-total]');

    if (!items.length) { page.hidden = true; return; }

    // Hide Shopify's "cart empty" message since we have local items
    const shopifyEmpty = document.getElementById('shopify-cart-empty');
    if (shopifyEmpty) shopifyEmpty.hidden = true;

    page.hidden = false;
    if (lines) lines.innerHTML = items.map((item, i) => staticLineMarkup(item, i)).join('');
    if (total) total.textContent = formatMoney(items.reduce((s, item) => s + item.price * item.quantity, 0));
  }

  /* ── Static asset host: rewrite relative links ── */
  function normalizeStaticAssetLinks() {
    if (!isAssetHost()) return;
    document.querySelectorAll('a[href^="/"]').forEach(link => {
      const href = link.getAttribute('href');
      if (href && !href.startsWith('//')) link.setAttribute('href', `${STORE_ORIGIN}${href}`);
    });
  }

  /* ── tyra_cart query param import ── */
  function importCartFromQuery() {
    const params  = new URLSearchParams(window.location.search);
    const payload = params.get('tyra_cart');
    if (!payload) return;
    try {
      const items = JSON.parse(decodeURIComponent(escape(atob(payload))));
      if (Array.isArray(items)) writeStaticCart(items);
      params.delete('tyra_cart');
      const next = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', next);
    } catch { /* ignore malformed payload */ }
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    importCartFromQuery();
    ensureDrawer();
    normalizeStaticAssetLinks();
    bindShopifyForms();
    bindStaticAddButtons();
    bindControls();
    renderLocalCartPage();
    renderDrawer(); // populate badge on load

    document.querySelectorAll('[data-cart-open]').forEach(el => {
      el.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
    });
  });

  document.addEventListener('tyra:cart:open', openDrawer);
})();
